module.exports = {"menu":{"one":{"number":"I","text":"Начало","name":"Part I"},"two":{"number":"II","text":"Военный vs художник<br>Рисовальщик vs живописец","name":"Part II"},"three":{"number":"III","text":"Россия vs мир<br>Дружба vs вражда","name":"Part III"},"four":{"number":"IV","text":"ПАТРИОТИЗМ VS КОСМОПОЛИТИЗМ<br>ХРИСТИАНИН VS АТЕИСТ","name":"Part IV"},"five":{"number":"V","text":"ВЕРЕЩАГИН И СПЕЦЭФФЕКТЫ","name":"Part V"},"six":{"number":"VI","text":"ЗАЧЕМ ИДТИ НА ВЫСТАВКУ ВЕРЕЩАГИНА<br>В ТРЕТЬЯКОВСКУЮ ГАЛЕРЕЮ?","name":"Part VI"}}}


//////////////////
// WEBPACK FOOTER
// ./js/nav.json
// module id = 546
// module chunks = 0